import { render, staticRenderFns } from "./CreateServiceGroupDialog.vue?vue&type=template&id=f143f898&scoped=true&"
import script from "./CreateServiceGroupDialog.vue?vue&type=script&lang=js&"
export * from "./CreateServiceGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateServiceGroupDialog.vue?vue&type=style&index=0&id=f143f898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f143f898",
  null
  
)

export default component.exports